import React from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Form,
  Image,
  FormGroup,
  OverlayTrigger,
  Tooltip,
  Tab,
  InputGroup,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import {
  getRekapLaporan,
  deleteLaporanKunjungan,
  responPatrol,
  getExportPatrol,
  updateStatusPatrol,
} from "../../../stores";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactDatetime from "react-datetime";
import { CardBody } from "reactstrap";
import moment from "moment";
import momentTZ from "moment-timezone";
import DataTable from "react-data-table-component";
import ReactPaginate from "react-paginate";
import "../css/Pagination.css";
// Loading Table
import { ColorRing } from "react-loader-spinner";
import Swal from "sweetalert2";

// Style Table
const options = [
  { value: 10, label: "10" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const customStyles = {
  table: {
    style: {
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    },
  },

  headRow: {
    style: {
      minHeight: "56px",
      background: "linear-gradient(90deg, #3473B6, #4A90E2)",
      borderBottom: "2px solid #e5e7eb",
    },
  },

  headCells: {
    style: {
      color: "#ffffff",
      fontSize: "14px",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      justifyContent: "center",
    },
  },

  rows: {
    style: {
      minHeight: "52px",
      fontSize: "14px",
      color: "#374151",
      backgroundColor: "#ffffff",
      "&:not(:last-of-type)": {
        borderBottom: "1px solid #e5e7eb",
      },
    },
    stripedStyle: {
      backgroundColor: "#f9fafb",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#eff6ff",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
    },
  },

  cells: {
    style: {
      padding: "12px 16px",
      justifyContent: "center",
    },
  },
};
const listShift = [
  { value: "Shift 1", label: "Shift 1" },
  { value: "Shift 2", label: "Shift 2" },
  { value: "Shift 3", label: "Shift 3" },
];
const listNamaStatus = [
  { value: "Telah Dikunjungi", label: "Visited" },
  { value: "Belum Dikunjungi", label: "No Visited Yet" },
  { value: "Tidak Dikunjungi", label: "Not Visited" },
  { value: "Menunggu Persetujuan", label: "Waiting for Approval" },
];
const listKondisi = [
  { value: "Normal", label: "Normal" },
  { value: "Tidak Normal", label: "Abnormal" },
];

function ReactTables() {
  const dispatch = useDispatch();
  const monitoring = useSelector((state) => state.monitoringReducer);
  const [modal, setModal] = React.useState(false);
  //   const [project, setProject] = React.useState({});
  const [data, setData] = React.useState([]);
  const [dataKunjungan, setDataKunjungan] = React.useState([]);
  const history = useHistory();
  const [modalPreviewFoto, setModalPreviewFoto] = React.useState(false);
  const [modalExport, setModalExport] = React.useState(false);
  const [tglAwlExport, setTglAwalExport] = React.useState("");
  const [tglAkhirExport, setTglAkhirExport] = React.useState("");
  const [statusLaporan, setStatusLaporan] = React.useState({
    value: "",
    label: "Choose the Action",
    isDisabled: true,
  });

  const [keteranganRespon, setKeteranganRespon] = React.useState("");

  // Pagination
  const date = new Date();

  const [dariTgl, setDariTgl] = React.useState(
    new Date(date.getFullYear(), date.getMonth(), 1).setHours(0, 0, 0, 0),
  );

  const [smpTgl, setSmpTgl] = React.useState(new Date().setHours(23, 59, 0, 0));
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);

  const [tglKunjungan, setTglKunjungan] = React.useState(
    new Date().setHours(7, 0, 0, 0),
  );
  const [searchText, setSearchText] = React.useState("");
  const [shift, setListShift] = React.useState({
    value: "",
    label: "ALL",
  });
  const [namaStatus, setNamaStatus] = React.useState({
    value: "",
    label: "ALL",
  });
  const [kondisi, setKondisi] = React.useState({
    value: "",
    label: "ALL",
  });
  // Update Status
  const [nama, setNama] = React.useState("");
  const [condition, setCondition] = React.useState("");
  const [keterangan, setKeterangan] = React.useState("");
  const [modalUpdatePatrol, setModalUpdatePatrol] = React.useState(false);
  const [ruangan, setRuangan] = React.useState("");
  const [gambar, setGambar] = React.useState([]);

  const conditionOption = [
    { value: "Normal", label: "Normal" },
    { value: "Tidak Normal", label: "Tidak Normal" },
    // { value: "Tidak Masuk", label: "Tidak Masuk" },
    // { value: "Sakit", label: "Sakit" },
    // {value:"Terlambat",label:"Terlambat"},
    // {value:"Keluarga",label:"Keluarga"},
    // {value:"Cuti",label:"Cuti"},
  ];
  const selectedConditionOption =
    conditionOption.find((opt) => opt.value === condition) || null;

  const [debouncedSearch, setDebouncedSearch] = React.useState(searchText);

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
    setPage(0);
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const handleClearSearch = () => {
    setSearchText("");
  };

  React.useEffect(() => {
    let tmp =
      monitoring.rekapLaporan.data &&
      monitoring.rekapLaporan.data.map((val, index) => {
        return {
          ...val,
          tglLaporan: !val.tanggalKunjungan
            ? "-"
            : moment(val.tanggalKunjungan).format("DD MMM YYYY"),
          waktuLaporan: !val.tanggalKunjungan
            ? "-"
            : moment(val.tanggalKunjungan).format("HH:mm"),
          name: !val.dilaporkanOleh ? "-" : val.dilaporkanOleh,
          statusKunjungan:
            val.status == "Belum Dikunjungi"
              ? "No Visited Yet"
              : val.status == "Tidak Dikunjungi"
                ? "Not Visited"
                : val.status == "Menunggu Persetujuan"
                  ? "Waiting for Approval"
                  : val.status == "Telah Dikunjungi" && val.inTime == true
                    ? "On Time"
                    : val.inTime == false
                      ? "Not On Time"
                      : "-",

          actions: (
            <div
              className="actions-right"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {val.status === "Belum Dikunjungi" && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Update Patrol</Tooltip>}
                >
                  <Button
                    onClick={() => {
                      setRuangan(val._id);
                      setModalUpdatePatrol(true);
                      setTglKunjungan(new Date().setHours(7, 0, 0, 0));
                      setCondition("");
                      setGambar([]);
                    }}
                    variant="link"
                    className="p-0 border-0 shadow-none"
                    style={{ textDecoration: "none" }}
                  >
                    <i
                      className="fas fa-edit fa-lg"
                      style={{
                        color: "#069AF3",
                      }}
                    />
                  </Button>
                </OverlayTrigger>
              )}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail Patrol</Tooltip>}
              >
                <Button
                  onClick={() => {
                    setDataKunjungan(val);
                    setModal(true);
                  }}
                  variant="link"
                  className="p-0 border-0 shadow-none"
                  style={{ textDecoration: "none" }}
                >
                  <i
                    className="fas fa-info-circle fa-lg"
                    style={{
                      color:
                        val.status === "Tidak Dikunjungi"
                          ? "#ff002f"
                          : val.status === "Menunggu Persetujuan"
                            ? "#2196F3"
                            : val.status === "Telah Dikunjungi" &&
                                val.inTime === true
                              ? "#0ed907"
                              : val.status === "Telah Dikunjungi" &&
                                  val.inTime === false
                                ? "#ff8000"
                                : "#7A7A7A",
                    }}
                  />
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setData(tmp);
  }, [monitoring.rekapLaporan]);

  React.useEffect(() => {
    setPage(0);
  }, [debouncedSearch, dariTgl, smpTgl, shift, namaStatus, kondisi]);

  React.useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 400);

    return () => clearTimeout(t);
  }, [searchText]);

  React.useEffect(() => {
    setLoading(true);
    getRekapLaporan(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
      dariTgl: momentTZ(new Date(dariTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      smpTgl: momentTZ(new Date(smpTgl))
        .tz("Asia/Jakarta")
        .format("YYYY-MM-DD"),
      shift: shift.value,
      namaStatus: namaStatus.value,
      kondisi: kondisi.value,
    }).then((response) => {
      setLoading(false);
    });
  }, [
    page,
    totalPerHalaman,
    debouncedSearch,
    dariTgl,
    smpTgl,
    shift,
    namaStatus,
    kondisi,
  ]);

  const submitExport = (e) => {
    e.preventDefault();
    getExportPatrol({
      tglAwal: tglAwlExport,
      tglAkhir: tglAkhirExport,
    });
  };

  // Data yang ditampilkan
  const colPencairan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => index + monitoring.rekapLaporan.pagingCounter,
    },
    {
      name: "Building",
      minWidth: "300px",
      center: true,
      selector: (row) => row.gedung,
    },
    {
      name: "Area",
      minWidth: "300px",
      center: true,
      selector: (row) => row.area,
    },
    {
      name: "Date of Report",
      minWidth: "300px",
      center: true,
      selector: (row) =>
        moment(row.tanggalString, "YYYY-MM-DD").format("DD MMM YYYY"),
    },
    {
      name: "Shift",
      minWidth: "100px",
      center: true,
      selector: (row) => row.namaShift,
    },
    {
      name: "Visitng",
      minWidth: "100px",
      center: true,
      selector: (row) => row.kunjunganKe,
    },
    {
      name: "Security Officer",
      minWidth: "200px",
      center: true,
      selector: (row) => row.dilaporkanOleh || "-",
    },
    {
      name: "Visiting Date",
      minWidth: "150px",
      center: true,
      selector: (row) => row.tglLaporan,
    },
    {
      name: "Visiting Time",
      minWidth: "150px",
      center: true,
      selector: (row) => row.waktuLaporan || "-",
    },

    {
      name: "Status",
      minWidth: "150px",
      center: true,
      selector: (row) => row.statusKunjungan,
    },
    {
      name: "Condition",
      minWidth: "150px",
      center: true,
      selector: (row) =>
        row.kondisi === "Normal"
          ? "Normal"
          : row.kondisi === "Tidak Normal"
            ? "Abnormal"
            : "-",
    },
    {
      name: "QR Code",
      minWidth: "150px",
      center: true,
      selector: (row) =>
        row.qr === true ? "Yes" : row.qr === false ? "No" : "-",
    },
    {
      name: "Action",
      minWidth: "150px",
      center: true,
      selector: (row) => row.actions,
    },
  ];

  const RegularMap = () => {
    const mapRef = React.useRef(null);
    React.useEffect(() => {
      let google = window.google;
      let map = mapRef.current;
      // let lat = "40.748817";
      // let lng = "-73.985428";
      const myLatlng = new google.maps.LatLng(
        dataKunjungan.latitude,
        dataKunjungan.longitude,
      );
      const mapOptions = {
        zoom: 17,
        center: myLatlng,
        scrollwheel: false,
      };

      map = new google.maps.Map(map, mapOptions);

      const marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        animation: google.maps.Animation.DROP,
        title: "Light Bootstrap Dashboard PRO React!",
      });

      // const contentString =
      //   '<div class="info-window-content"><h2>Light Bootstrap Dashboard PRO React</h2>' +
      //   "<p>A premium Admin for React-Bootstrap, Bootstrap, React, and React Hooks.</p></div>";

      // const infowindow = new google.maps.InfoWindow({
      //   content: contentString,
      // });

      // google.maps.event.addListener(marker, "click", function () {
      //   infowindow.open(map, marker);
      // });
    }, []);
    return (
      <>
        <div className="map" id="regularMap" ref={mapRef} />
      </>
    );
  };
  const updatePatrol = () => {
    if (nama === "") {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Silahkan isi nama!",
      });
    }
    if (condition === "") {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Silahkan pilih status!",
      });
    }
    if (keterangan === "") {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Semua field harus diisi!",
      });
    }

    Swal.fire({
      title: "Update Status Patrol",
      text: "Yakin ingin melakukan update status ruangan ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Update!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        let fd = new FormData();

        fd.append("ruangan", ruangan);
        fd.append("nama_karyawan", nama);
        fd.append("kondisi", condition);
        fd.append("keterangan", keterangan);
        fd.append(
          "tglKunjungan",
          moment(tglKunjungan).format("YYYY-MM-DD HH:mm:ss"),
        );
        gambar.map((val, index) => [fd.append("dokumentasiAwalArr", val)]);
        updateStatusPatrol(fd).then((response) => {
          if (response.status === 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            setModalUpdatePatrol(false);
            getRekapLaporan(dispatch, {
              page: page + 1,
              limit: totalPerHalaman,
              cari: searchText,
              dariTgl: momentTZ(new Date(dariTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              smpTgl: momentTZ(new Date(smpTgl))
                .tz("Asia/Jakarta")
                .format("YYYY-MM-DD"),
              shift: shift.value,
              namaStatus: namaStatus.value,
              kondisi: kondisi.value,
            });
          } else if (response.status === 400) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        });
      }
    });
  };

  return (
    <>
      <div
        id="previewImage"
        style={{
          display: modalPreviewFoto ? "block" : "none",
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: "9999",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={modalPreviewFoto}
          alt="Preview"
          style={{
            borderRadius: "5px",
            boxShadow: "4px 4px 8px 0px rgba(0,0,0,0.75)",
            maxHeight: "80%",
            maxWidth: "80%",
            objectFit: "contain",
            background: "transparent",
            position: "absolute",
            top: "50%", // Posisi vertikal ke tengah
            left: "50%", // Posisi horizontal ke tengah
            transform: "translate(-50%, -50%)",
          }}
        />
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            cursor: "pointer",
          }}
          onClick={() => setModalPreviewFoto("")}
        >
          &times;
        </button>
      </div>
      <Container fluid>
        <Row>
          <Col md="12">
            <h4 className="title">Visiting Report</h4>

            {/* <Card>
              <Card.Body>
                <ReactTable
                  data={data}
                  showPagination={false}
                  columns={[
                    {
                      Header: "Building",
                      accessor: "gedung",
                    },
                    {
                      Header: "Area",
                      accessor: "area",
                    },
                    {
                      Header: "Name",
                      accessor: "name",
                    },
                    {
                      Header: "Visiting Date",
                      accessor: "tglLaporan",
                    },
                    {
                      Header: "Status",
                      accessor: "status",
                    },

                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  // className="-striped -highlight "
                />
              </Card.Body>
            </Card> */}

            <Card style={{ backgroundColor: "white" }}>
              <Card.Header>
                <Tab.Content>
                  <>
                    <Row
                      style={{
                        display: "flex",
                        // justifyContent: "space-between",
                        // auth.role === "cabang" ? null : "space-between",
                        // padding: "0 15px",
                      }}
                    >
                      <Col md="2">
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: 12,
                            color: "black",
                          }}
                        >
                          {" "}
                          Start Date
                        </label>
                        <Form.Group>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date Picker Here",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                backgroundColor: "white",
                                color: "black !important",
                              },
                            }}
                            onChange={(e) => {
                              setDariTgl(e.toDate().getTime());
                            }}
                            value={dariTgl}
                            // initialValue={dariTgl}
                            timeFormat={false}
                            dateFormat="DD MMM YYYY"
                          ></ReactDatetime>
                        </Form.Group>
                      </Col>
                      <Col md="2">
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: 12,
                            color: "black",
                          }}
                        >
                          {" "}
                          End Date
                        </label>
                        <Form.Group>
                          <ReactDatetime
                            inputProps={{
                              className: "form-control",
                              placeholder: "Date Picker Here",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                backgroundColor: "white",
                                color: "black !important",
                              },
                            }}
                            onChange={(e) => {
                              setSmpTgl(e.toDate().setHours(23, 59, 59, 0));
                            }}
                            value={smpTgl}
                            // initialValue={dariTgl}
                            timeFormat={false}
                            dateFormat="DD MMM YYYY"
                          ></ReactDatetime>
                        </Form.Group>
                      </Col>

                      <Col md="2">
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: 12,
                          }}
                        >
                          {" "}
                          Shift Filter
                        </label>
                        <Select
                          className="react-select primary pb-2"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          onChange={(value) => {
                            setListShift(value);
                          }}
                          value={shift}
                          options={[
                            {
                              value: "",
                              label: "ALL",
                              // isDisabled: true,
                            },
                            ...listShift,
                          ]}
                          placeholder="Single Select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              cursor: "pointer",
                            }),
                            option: (base, state) => ({
                              ...base,
                              cursor: "pointer",
                            }),
                          }}
                        />
                      </Col>
                      <Col md="2">
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: 12,
                          }}
                        >
                          {" "}
                          Status Filter
                        </label>
                        <Select
                          className="react-select primary pb-2"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          onChange={(value) => {
                            setNamaStatus(value);
                            // setListShift({ value: "", label: "ALL" });
                          }}
                          value={namaStatus}
                          options={[
                            {
                              value: "",
                              label: "ALL",
                              // isDisabled: true,
                            },
                            ...listNamaStatus,
                          ]}
                          placeholder="Single Select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              cursor: "pointer",
                            }),
                            option: (base, state) => ({
                              ...base,
                              cursor: "pointer",
                            }),
                          }}
                        />
                      </Col>
                      <Col md="2">
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "bold",
                            color: "black",
                            fontSize: 12,
                          }}
                        >
                          {" "}
                          Condition Filter
                        </label>
                        <Select
                          className="react-select primary pb-2"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          onChange={(value) => {
                            setKondisi(value);
                            // setListShift({ value: "", label: "ALL" });
                          }}
                          value={kondisi}
                          options={[
                            {
                              value: "",
                              label: "ALL",
                              // isDisabled: true,
                            },
                            ...listKondisi,
                          ]}
                          placeholder="Single Select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              cursor: "pointer",
                            }),
                            option: (base, state) => ({
                              ...base,
                              cursor: "pointer",
                            }),
                          }}
                        />
                      </Col>
                      <Col md="2">
                        <label
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontWeight: "bold",
                            color: "transparent", // label kosong tapi ambil space
                            fontSize: 12,
                          }}
                        >
                          Export
                        </label>
                        <Button
                          // variant="info"
                          style={{
                            fontSize: 12,
                            fontWeight: "bold",
                            backgroundColor: "#4c6fc8",
                            border: 0,
                            textAlign: "center",
                          }}
                          onClick={(e) => {
                            setModalExport(true);
                          }}
                        >
                          <i class="fas fa-file-excel"></i>
                          Export Data
                        </Button>
                      </Col>
                    </Row>
                  </>

                  <Card
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 10,
                      border: 0,
                    }}
                  >
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {/* Label Search */}
                      <Col
                        md="auto"
                        style={{
                          fontWeight: 600,
                          marginRight: 10,
                          fontSize: 22,
                          whiteSpace: "nowrap",
                          marginTop: 6,
                        }}
                      >
                        Search :
                      </Col>
                      <Col md={"3"} style={{ display: "flex" }}>
                        <InputGroup>
                          <Form.Control
                            style={{
                              paddingLeft: "10px",
                            }}
                            type="text"
                            value={searchText}
                            onChange={handleSearch}
                            placeholder="Building, Area or Officer Name"
                          />
                          <InputGroup.Append>
                            <InputGroup.Text
                              className="input-group-sm mb-1"
                              style={{
                                cursor: "pointer",
                                marginLeft: "auto",
                              }}
                              onClick={handleClearSearch}
                            >
                              <i class="fas fa-times"></i>
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                      {/* <Col md={"0"}>
                        <Button
                          // variant="info"
                          style={{
                            fontSize: 16,
                            backgroundColor: "#4c6fc8",
                            border: 0,
                            // paddingTop: 5,
                            marginRight: 15,
                            paddingBottom: 8,
                          }}
                          onClick={handleFilterChange}
                        >
                          <i class="fas fa-search"></i>
                        </Button>
                      </Col> */}
                    </Row>
                  </Card>
                </Tab.Content>
              </Card.Header>
              <Card.Body>
                {loading ? (
                  <div
                    className="loader-container"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <ColorRing
                      visible={true}
                      height="80"
                      width="80"
                      ariaLabel="color-ring-loading"
                      wrapperStyle={{}}
                      wrapperClass="color-ring-wrapper"
                      colors={[
                        "#394978",
                        "#394978",
                        "#394978",
                        "#394978",
                        "#394978",
                      ]}
                    />
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 19,
                      }}
                    ></p>
                  </div>
                ) : (
                  <DataTable
                    columns={colPencairan}
                    data={data}
                    // {listPencairan.filter(
                    //   (row) =>
                    //     row.id_pinjaman
                    //       .toLowerCase()
                    //       .includes(searchText.toLowerCase()) ||
                    //     row.namaLengkap
                    //       .toLowerCase()
                    //       .includes(searchText.toLowerCase())
                    // )}
                    customStyles={customStyles}
                    paginationPerPage={totalPerHalaman}
                    progressPending={loading}
                  />
                )}

                <div style={{ marginTop: 35 }}>
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Col>
                      <Row style={{ alignItems: "center" }}>
                        <div
                          style={{
                            paddingRight: 0,
                            marginLeft: 20,
                            marginRight: 10,
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Rows per page
                          </label>
                        </div>
                        <Col sm="3" style={{ paddingLeft: 0 }}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="Pilih Client"
                            value={options.find(
                              (option) => option.value === totalPerHalaman,
                            )}
                            onChange={handlePageSizeChange}
                            options={options}
                            placeholder="Rows per page"
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <ReactPaginate
                        forcePage={page}
                        containerClassName="paginations justify-content-end"
                        previousClassName="pages-items-containers"
                        previousLinkClassName="pages-links-labels"
                        nextClassName="pages-items-containers"
                        nextLinkClassName="pages-links-labels"
                        breakClassName="pages-items-containers"
                        pageCount={monitoring.rekapLaporan.totalPages}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        pageLinkClassName="pages-links-labels"
                        pageClassName="pages-items-containers"
                        activeClassName="actives"
                        activeLinkClassName="activess"
                        nextLabel=" > "
                        previousLabel=" < "
                        // initialPage={"page"}
                        disableInitialCallback={true}
                        onPageChange={(val) => {
                          setPage(val.selected);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        size="lg"
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold" }}
          >
            Visit
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              {dataKunjungan &&
              dataKunjungan.status === "Menunggu Persetujuan" ? (
                <>
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">Report Validation</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col sm="12">
                          <Form.Group>
                            <label>Action</label>
                            <Select
                              className="react-select primary pb-2"
                              classNamePrefix="react-select"
                              name="singleSelect"
                              onChange={(value) => {
                                setStatusLaporan(value);
                              }}
                              value={statusLaporan}
                              options={[
                                {
                                  value: "",
                                  label: "Choose",
                                  isDisabled: true,
                                },
                                {
                                  value: "Laporan Diterima",
                                  label: "Approve",
                                },
                                {
                                  value: "Laporan Ditolak",
                                  label: "Reject",
                                },

                                ,
                              ]}
                              placeholder="Single Select"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm="12">
                          <Form.Group>
                            <label>Description</label>
                            <Form.Control
                              onChange={(e) => {
                                setKeteranganRespon(e.target.value);
                              }}
                              // placeholder="Masukan Nama Ruangan"
                              as="textarea"
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e) => {
                          e.preventDefault();
                          if (!statusLaporan || !keteranganRespon) {
                            Swal.fire({
                              title: "Please complete the form!",
                              icon: "warning",
                            });
                          } else {
                            responPatrol({
                              idKunjungan: dataKunjungan._id,
                              statusLaporan: statusLaporan.value,
                              keteranganRespon: keteranganRespon,
                            });
                          }
                        }}
                      >
                        Submit
                      </Button>
                    </Card.Body>
                  </Card>
                </>
              ) : null}
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Detail Patrol</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Building
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">{dataKunjungan.gedung}</Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Area
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">{dataKunjungan.area}</Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Date of Report
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {moment(
                        dataKunjungan?.tanggalString,
                        "YYYY-MM-DD",
                      ).format("DD MMM YYYY") || "-"}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Shift
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">{dataKunjungan.namaShift}</Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Visiting
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">{dataKunjungan.kunjunganKe}</Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Security Officer
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {!dataKunjungan.dilaporkanOleh
                        ? "-"
                        : dataKunjungan.dilaporkanOleh}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Visiting Date
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {!dataKunjungan.tanggalKunjungan
                        ? "-"
                        : moment(dataKunjungan.tanggalKunjungan).format(
                            "DD MMM YYYY",
                          )}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Visiting Time
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {!dataKunjungan.tanggalKunjungan
                        ? "-"
                        : moment(dataKunjungan.tanggalKunjungan).format(
                            "HH:mm",
                          )}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Status
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {dataKunjungan.status == "Belum Dikunjungi"
                        ? "No Visited Yet"
                        : dataKunjungan.status == "Tidak Dikunjungi"
                          ? "Not Visited"
                          : dataKunjungan.status == "Menunggu Persetujuan"
                            ? "Waiting for Approval"
                            : dataKunjungan.status == "Telah Dikunjungi" &&
                                dataKunjungan.inTime == true
                              ? "On Time"
                              : dataKunjungan.status == "Telah Dikunjungi" &&
                                  dataKunjungan.inTime == false
                                ? "Not On Time"
                                : "-"}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Condition
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {dataKunjungan.kondisi === "Normal"
                        ? "Normal"
                        : dataKunjungan.kondisi === "Tidak Normal"
                          ? "Abnormal"
                          : "-"}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      QR Code
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {dataKunjungan.qr === true
                        ? "Yes"
                        : dataKunjungan.qr === false
                          ? "No"
                          : "-"}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" style={{ fontWeight: "bold" }}>
                      Note
                    </Col>
                    <Col sm="0.5">:</Col>
                    <Col sm="5">
                      {!dataKunjungan.keterangan
                        ? "-"
                        : dataKunjungan.keterangan}
                    </Col>
                  </Row>
                  {/* {dataKunjungan.qr === false && (
                    <>
                      <Row>
                        <Col
                          sm="6"
                          style={{ fontWeight: "bold", fontSize: 20 }}
                        >
                          Approval Review Details
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6" style={{ fontWeight: "bold" }}>
                          Respon By
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="5">{dataKunjungan?.diResponOleh || "-"}</Col>
                      </Row>
                      <Row>
                        <Col sm="6" style={{ fontWeight: "bold" }}>
                          Date Respon
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="5">
                          {!dataKunjungan?.tanggalRespon
                            ? "-"
                            : moment(dataKunjungan?.tanggalRespon).format(
                                "DD MMM YYYY / HH:MM",
                              )}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6" style={{ fontWeight: "bold" }}>
                          Report Status
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="5">
                          {dataKunjungan?.statusLaporan === "Laporan Diterima"
                            ? "Approve"
                            : dataKunjungan?.statusLaporan === "Laporan Ditolak"
                              ? "Rejected"
                              : "-"}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6" style={{ fontWeight: "bold" }}>
                          Note Respon
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="5">
                          {dataKunjungan?.keteranganRespon || "-"}
                        </Col>
                      </Row>
                    </>
                  )} */}
                  <Row style={{ marginTop: 30 }}>
                    <Col
                      sm="12"
                      style={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Documentation
                    </Col>
                  </Row>
                  <Row>
                    {!dataKunjungan.dokumentasiAwalArr ||
                    dataKunjungan.dokumentasiAwalArr.length == 0 ? (
                      <Col sm="12" style={{ textAlign: "center" }}>
                        Documentation is Not Available
                      </Col>
                    ) : (
                      dataKunjungan.dokumentasiAwalArr.map((val, index) => {
                        return (
                          <>
                            <Col sm="4">
                              <Image
                                h
                                src={val}
                                style={{
                                  width: 200,
                                  height: 250,
                                  margin: 20,
                                  cursor: "pointer",
                                }}
                                thumbnail
                                onClick={() => {
                                  setModalPreviewFoto(val);
                                }}
                              />
                            </Col>
                          </>
                        );
                      })
                    )}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            {/* <Col md="6">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Location</Card.Title>
                </Card.Header>
                <Card.Body>
                  <RegularMap />
                </Card.Body>
              </Card>
            </Col> */}
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalExport}
        onHide={() => {
          setModalExport(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card style={{ border: 0 }}>
                  <Card.Header>
                    <Card.Header>
                      <Card.Title
                        as="h4"
                        style={{
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textAlign: "center",
                        }}
                      >
                        Export Data Patrol
                        <hr></hr>
                      </Card.Title>
                    </Card.Header>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Start Date
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAwalExport(e.target.value);
                            }}
                            type="date"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            End Date
                          </label>
                          <Form.Control
                            onChange={(e) => {
                              setTglAkhirExport(e.target.value);
                            }}
                            type="date"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Button
                      // className="btn-fill pull-right"
                      // type="submit"
                      // variant="info"
                      style={{
                        marginTop: 5,
                        backgroundColor: "#417DA0",
                        border: 0,
                        fontWeight: "bold",
                      }}
                      onClick={submitExport}
                    >
                      Submit
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalUpdatePatrol}
        onHide={() => {
          setModalUpdatePatrol(false);
          setGambar([]);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title id="example-modal-sizes-title-lg">
                  Large Modal
                </Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Card className="stacked-form">
                <Card.Header>
                  <Card.Title as="h4">Update Status Patrol</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Form action="#" method="#">
                    <Form.Group>
                      <label>Officer Name</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="text"
                        onChange={(e) => {
                          setNama(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>

                    <Form.Group>
                      <label>Date Visit</label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control",
                          placeholder: "Date Picker Here",
                          readOnly: true,
                          style: {
                            cursor: "pointer",
                            backgroundColor: "white",
                            color: "black !important",
                          },
                        }}
                        onChange={(e) => {
                          setTglKunjungan(e.toDate().getTime());
                        }}
                        value={moment(tglKunjungan)}
                        timeFormat="HH:mm:ss"
                      ></ReactDatetime>
                    </Form.Group>
                    <Form.Group>
                      <label>Condition</label>
                      <Select
                        options={conditionOption}
                        value={selectedConditionOption}
                        onChange={(selected) => {
                          setCondition(selected.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <label>Note</label>
                      <Form.Control
                        as="textarea"
                        // value={keterangan !== "" ? keterangan : ""}
                        onChange={(e) => {
                          setKeterangan(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>

                    <label>Documentation</label>
                    <br />
                    {gambar.length < 3 ? (
                      <>
                        <label
                          className="label-input-file btn btn-danger text-white mb-4"
                          for="import2"
                        >
                          Add Photo
                          <input
                            type="file"
                            id="import2"
                            onClick={(e) => {
                              e.target.value = "";
                            }}
                            onChange={(e) => {
                              setGambar([
                                ...gambar,
                                ...Array.from(e.target.files),
                              ]);
                            }}
                            style={{ display: "none" }}
                            accept="image/*"
                            multiple
                          />
                        </label>
                      </>
                    ) : null}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "15px",
                        marginTop: "15px",
                      }}
                    >
                      {gambar.map((val, index) => {
                        // Handle both File objects dan image URLs
                        const isNewFile = val instanceof File;
                        const imageUrl = isNewFile
                          ? URL.createObjectURL(val)
                          : val.url || val;
                        const imageName =
                          val.name ||
                          (isNewFile ? val.name : `Image ${index + 1}`);

                        return (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              border: isNewFile
                                ? "3px solid #4CAF50"
                                : "2px solid #e0e0e0",
                              borderRadius: "8px",
                              overflow: "hidden",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            <img
                              src={imageUrl}
                              alt={`preview-${index}`}
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                                display: "block",
                              }}
                              onError={(e) => {
                                e.target.src =
                                  "https://via.placeholder.com/150?text=Invalid+Image";
                              }}
                            />
                            {isNewFile && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  left: "5px",
                                  backgroundColor: "#4CAF50",
                                  color: "white",
                                  fontSize: "10px",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  fontWeight: "bold",
                                }}
                              >
                                NEW
                              </div>
                            )}
                            <Button
                              onClick={() => {
                                setGambar([
                                  ...gambar.slice(0, index),
                                  ...gambar.slice(index + 1, gambar.length),
                                ]);
                              }}
                              variant="danger"
                              size="sm"
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                borderRadius: "50%",
                                width: "32px",
                                height: "32px",
                                padding: "0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "rgba(255, 0, 0, 0.8)",
                                border: "none",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor =
                                  "rgba(255, 0, 0, 1)";
                                e.target.style.transform = "scale(1.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor =
                                  "rgba(255, 0, 0, 0.8)";
                                e.target.style.transform = "scale(1)";
                              }}
                            >
                              <i
                                className="fa fa-times"
                                style={{ color: "white", fontSize: "16px" }}
                              />
                            </Button>
                            <div
                              style={{
                                padding: "8px",
                                fontSize: "12px",
                                color: "#666",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                backgroundColor: "#fafafa",
                                borderTop: "1px solid #e0e0e0",
                              }}
                            >
                              {imageName}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Form>
                </Card.Body>
                <Card.Footer>
                  <Button
                    onClick={() => {
                      updatePatrol();
                    }}
                    className="btn-fill"
                    type="submit"
                    variant="info"
                  >
                    Submit
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ReactTables;
